// Vite does not generate a service worker for this application. Remove any
// registrations left by the previous Create React App build so stale assets
// cannot survive a deployment.
export function unregister () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => Promise.all(
        registrations.map(registration => registration.unregister())
      ))
      .catch(error => {
        console.error('Unable to unregister legacy service workers:', error);
      });
  }
}
